import PaginatedList from '@theme/paginated-list';

export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    // Stänger av infinite scroll helt
    // Shopifys inbyggda paginering i Liquid tar över
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}